module.exports = __webpack_public_path__ + "static/media/01-levantamento.4b3b3412.png";